import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedNumber } from 'components/shared/Intl';
import { AmountReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryAmountFieldProps {
  node: AmountReadonlyValueDefinition;
}

export const ProductSummaryAmountField: FC<ProductSummaryAmountFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <div className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        <>
          <FormattedNumber maximumFractionDigits={4} value={data?.value} /> {data?.unit}
        </>
      </div>
    </SummaryFieldRow>
  );
};

ProductSummaryAmountField.displayName = 'ProductSummaryAmountField';
